export const VALIDATE_EMAIL_REQUEST = 'VALIDATE_EMAIL_REQUEST'
export const VALIDATE_EMAIL_RESET = 'VALIDATE_EMAIL_RESET'
export const VALIDATE_EMAIL_SUCCESS = 'VALIDATE_EMAIL_SUCCESS'
export const VALIDATE_EMAIL_ERROR = 'VALIDATE_EMAIL_ERROR'
export const VALIDATE_EMAIL_SEND_SUCCESS = 'VALIDATE_EMAIL_SEND_SUCCESS'
export const VALIDATE_EMAIL_SEND_ERROR = 'VALIDATE_EMAIL_SEND_ERROR'
